"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-FormDesignerPalette',
    title: 'c-FormDesignerPalette__title',
    list: {
        container: 'c-FormDesignerPalette__list'
    },
    field: {
        container: 'c-FormDesignerPalette__field',
        title: 'c-FormDesignerPalette__title',
        isActive: 'c-FormDesignerPalette--is-active'
    }
};
exports.Style = {
    [exports.CSS.list.container]: {
        display: 'flex',
        'flex-wrap': 'wrap',
        [`& .${exports.CSS.field.container}:hover`]: {
            cursor: 'pointer',
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2,
            'background-color': theme_1.DefaultTheme.font.color.divider
        }
    },
    [exports.CSS.container]: {
        display: 'flex',
        'align-items': 'center',
        'flex-direction': 'column',
        'margin-top': theme_1.DefaultTheme.space(2)
    },
    [exports.CSS.field.container]: {
        width: theme_1.DefaultTheme.space(25),
        padding: theme_1.DefaultTheme.space(3) + ' 0',
        'text-align': 'center',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'flex-direction': 'column'
    },
    [exports.CSS.field.title]: {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    [exports.CSS.field.isActive]: {
        color: theme_1.DefaultTheme.font.color.link
    }
};
//# sourceMappingURL=form.palette.style.js.map